export default "__VITE_ASSET__C$Vt1$_8__"